export default Object.freeze({
  MAX_DURATION: 24 * 60 * 60 * 1000,
  DEFAULT_DURATION: 30 * 60 * 1000,
  EXPORT_STATE: ['EXPORTING', 'NORMAL', 'ERROR', 'INVALID']
});
